import { TextField } from '@cfa/react-components';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const DeliveryTipsCustomAmount = (props) => {
  const {
    isSelect,
    onBlurHandler,
    beforeInputHandler,
    onInputHandler,
    onKeyDownHandler,
    selectedCustomTipValue,
  } = props;

  return (
    <StyledCustomTipAmount
      isSelect={isSelect}
      selectedCustomTipValue={selectedCustomTipValue}
      className="styled-custom-tip-amount"
    >
      <TextField
        type="number"
        id="customTip"
        placeholder="0.00"
        onBlur={onBlurHandler}
        onInput={onInputHandler}
        onBeforeInput={beforeInputHandler}
        onKeyDown={onKeyDownHandler}
        fullWidth
        label="Custom Tip Amount"
        defaultValue={selectedCustomTipValue !== 0 ? selectedCustomTipValue : ''}
        className="custom-amount-input"
        min={0}
        step={0.01}
        max={99999}
      />
    </StyledCustomTipAmount>
  );
};

DeliveryTipsCustomAmount.propTypes = {
  isSelect: PropTypes.bool,
  onBlurHandler: PropTypes.func,
  onInputHandler: PropTypes.func,
  beforeInputHandler: PropTypes.func,
  onKeyDownHandler: PropTypes.func,
  selectedCustomTipValue: PropTypes.number,
};

DeliveryTipsCustomAmount.defaultProps = {
  isSelect: false,
  onBlurHandler: () => {},
  onInputHandler: () => {},
  beforeInputHandler: () => {},
  onKeyDownHandler: () => {},
  selectedCustomTipValue: 0,
};

export const StyledCustomTipAmount = styled('div')`
  position: relative;

  & input {
    text-align: left;
    border-radius: 6px;
    padding: 0px 19px;
    min-height: 48px;
  }
  &::after {
    content: '$';
    position: absolute;
    left: 11px;
    top: 49px;
    transform: translate(0, -50%);
  }
`;

export default DeliveryTipsCustomAmount;
